export default __webpack_public_path__ + "static/media/logo.99e97fcf.png";